module.exports = __webpack_public_path__ + "img/1_1-parcheggio-1-bus.53dee0f9.png";